import HomePageLayout from 'global/HomePageLayout';
import SEO from 'global/SEO';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import GoogleMap from 'features/static/GoogleMap';
import {
  address,
  companyEmail,
  companyName,
  marketingEmail,
  supportEmail,
} from 'constants/company';
import {
  ContactBox,
  ContactContainer,
  ContactInner,
  Container,
  GoogleMapContainer,
  Header,
  HeaderContent,
} from './styled';

const Contact = () => (
  <HomePageLayout hideStartInvesting>
    <SEO title="Contact | Stockbit - Komunitas Saham Indonesia" />
    <Header>
      <Container>
        <HeaderContent>
          <Text as="h1" family="bold">
            Kontak Kami
          </Text>
          <Text as="p">Kirim pertanyaan kamu melalui kontak di bawah ini:</Text>
        </HeaderContent>
      </Container>
    </Header>
    <Container>
      <ContactContainer>
        <ContactBox>
          <GoogleMapContainer>
            <GoogleMap />
          </GoogleMapContainer>
          <div className="address">
            <Text as="h5" color={color.primary} family="bold">
              {companyName}
            </Text>
            <p>{address}</p>
          </div>
        </ContactBox>
        <ContactBox>
          <ContactInner>
            <Text as="h5" family="bold">
              Kontak Utama
            </Text>
            <Text as="p">
              Untuk segala pertanyaan dan masalah, kamu dapat mengunjungi pusat
              bantuan kami. Jika kamu membutuhkan bantuan lebih jauh, kamu dapat
              mengirimkan email ke{' '}
              <Text as="span" color={color.primary}>
                {supportEmail}
              </Text>
              .
            </Text>
            <Text as="h5" family="bold">
              Kerja Sama Iklan
            </Text>
            <Text as="p">
              Untuk melakukan kerja sama iklan, kamu dapat mengirimkan proposal
              penawaran ke{' '}
              <Text as="span" color={color.primary}>
                {marketingEmail}
              </Text>
              .
            </Text>
            <Text as="h5" family="bold">
              Kerja Sama Pers
            </Text>
            <Text as="p">
              Kamu membutuhkan informasi dari Stockbit? Kirimkan detail
              informasi yang ingin kamu dapatkan melalui{' '}
              <Text as="span" color={color.primary}>
                {supportEmail}
              </Text>
              .
            </Text>
            <Text as="h5" family="bold">
              Buka Akun Official di Stockbit
            </Text>
            <Text as="p">
              Jika kamu merupakan bagian dari sebuah perusahaan publik, kamu
              dapat mengirimkan email ke{' '}
              <Text as="span" color={color.primary}>
                {companyEmail}
              </Text>{' '}
              untuk informasi terkait kerja sama.
            </Text>
          </ContactInner>
        </ContactBox>
      </ContactContainer>
    </Container>
  </HomePageLayout>
);

export default Contact;
